// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"607":"e3fb7d76","779":"174f72ef","787":"5483c834","931":"359f8c4c","987":"647d5784"}[chunkId] + ".chunk.js";
};